import { render } from "./PastReunions.vue?vue&type=template&id=319b8c23"
import script from "./PastReunions.vue?vue&type=script&lang=ts"
export * from "./PastReunions.vue?vue&type=script&lang=ts"
script.render = render

export default script